import { render, staticRenderFns } from "./warehouse.vue?vue&type=template&id=28d63dae&scoped=true"
import script from "./warehouse.vue?vue&type=script&lang=js"
export * from "./warehouse.vue?vue&type=script&lang=js"
import style0 from "./warehouse.vue?vue&type=style&index=0&id=28d63dae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d63dae",
  null
  
)

export default component.exports